import Text from "./Text";

import "./Text.scss";

export * from "./Text.types";
export * from "./Text.variations";

export { Text };
